import update from 'immutability-helper';
import _, {isEmpty} from 'lodash';
import {useMemo} from 'react';

import {useAppSelector} from '../../../hooks/redux';
import {DashboardPanelData} from '../../../interfaces/Dashboard';
import {
  injectDashboardDates,
  useDashboardDates,
} from '../../../utils/dashboardDate';
import {
  AlarmLogTrackingReports,
  AlarmLogTrackingReportsData,
  getAlarmLogTrackingReportsData,
} from './AlarmLogTrackingReports';

interface Props {
  value?: DashboardPanelData;
  onUpdate?: (value?: DashboardPanelData) => void;
}
export interface AlarmNodeTrackingReportsData {
  viewType: 'alarms';
  title: string;
  alarm_log: AlarmLogTrackingReportsData;
}

const getAlarmNodeTrackingReports = (): AlarmNodeTrackingReportsData => ({
  viewType: 'alarms',
  title: 'Alarm Log Tracking Reports',
  alarm_log: getAlarmLogTrackingReportsData(),
});

export const AlarmLogReports = ({value, onUpdate}: Props) => {
  const alarms = useAppSelector(({assets}) => assets.alarm_modules);
  const config = useMemo(() => {
    if (alarms?.length > 0) {
      let v = !isEmpty(value)
        ? (value as AlarmNodeTrackingReportsData)
        : getAlarmNodeTrackingReports();
      if (v?.alarm_log?.activeId) {
        const objectsToRemove = _.differenceBy(
          v?.alarm_log?.openedItems,
          alarms,
          'id'
        );
        if (objectsToRemove?.length > 0) {
          const openedItems = _.differenceBy(
            v?.alarm_log?.openedItems,
            objectsToRemove,
            'id'
          );
          const opentedItemIds = openedItems?.map((it) => it?.id);
          let activeId: number | undefined = v?.alarm_log?.activeId;
          if (!opentedItemIds?.includes(v?.alarm_log?.activeId)) {
            activeId =
              opentedItemIds?.length > 0 ? opentedItemIds[0] : undefined;
          }

          v = {
            ...v,
            alarm_log: {
              ...v.alarm_log,
              activeId: activeId,
              openedItems: openedItems,
            },
          };
        }
        return v;
      } else {
        return v;
      }
    } else {
      return getAlarmNodeTrackingReports();
    }
  }, [value, alarms]);

  // console.log(config.alarm_log)

  const dashboardDates = useDashboardDates(value?.detachedFromDashboardDate);

  const alarmLogValue = useMemo(() => {
    const base = config.alarm_log;
    if (!dashboardDates) {
      return base;
    }
    const newItems = injectDashboardDates(base.openedItems, dashboardDates);
    if (newItems === base.openedItems) {
      return base;
    }
    return {...base, openedItems: newItems};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config.alarm_log, dashboardDates?.date_start, dashboardDates?.date_end]);

  return (
    <AlarmLogTrackingReports
      value={alarmLogValue}
      onUpdate={(v) => {
        let detach = false;
        if (
          dashboardDates &&
          v?.openedItems &&
          v.openedItems.length === config.alarm_log.openedItems.length
        ) {
          const activeIdx = v.openedItems.findIndex(
            (it) => it.id === (v.activeId ?? config.alarm_log.activeId)
          );
          const incoming =
            activeIdx >= 0 ? v.openedItems[activeIdx] : undefined;
          if (
            incoming &&
            (incoming.params?.date_start !== dashboardDates.date_start ||
              incoming.params?.date_end !== dashboardDates.date_end)
          ) {
            detach = true;
          }
        }
        const base = update(value ?? getAlarmNodeTrackingReports(), {
          alarm_log: {$set: v ?? getAlarmLogTrackingReportsData()},
        });
        onUpdate?.(detach ? {...base, detachedFromDashboardDate: true} : base);
      }}
    />
  );
};
